export const serviceListDemoData = [
    {
        id: 3,
        user: {
            id: 49,
            firstName: 'Mir',
            lastName: 'Sayem',
            fullName: 'Mir Sayem',
            organization: 'Pridesys IT',
            primaryEmail: 'pridesys0080@gmail.com',
            primaryPhone: '0155000080',
            demo: true
        },
        productType: 'service',
        subscriptionId: 0,
        applicationId: 1,
        serviceName: 'Installation',
        timeInitiate: 1708580850,
        timeImplement: 1708581538,
        timeOngoing: 1708581549,
        timeDone: 1708581710,
        timeUpdated: 1708581710,
        status: 'completed',
        demo: true
    },
    {
        id: 2,
        user: {
            id: 5,
            firstName: 'Noman',
            lastName: 'Gazi',
            fullName: 'Noman Gazi',
            organization: 'Noman Co..',
            primaryEmail: 'contact@noman.me',
            primaryPhone: '01777777777',
            demo: true
        },
        productType: 'service',
        subscriptionId: 0,
        applicationId: 2,
        serviceName: 'Backup',
        timeInitiate: 1708573006,
        timeImplement: 1708580518,
        timeOngoing: 1708581026,
        timeDone: 1708582139,
        timeUpdated: 1708582139,
        status: 'completed',
        demo: true
    },
    {
        id: 4,
        user: {
            id: 5,
            firstName: 'Noman',
            lastName: 'Gazi',
            fullName: 'Noman Gazi',
            organization: 'Noman Co..',
            primaryEmail: 'contact@noman.me',
            primaryPhone: '01777777777',
            demo: true
        },
        productType: 'service',
        subscriptionId: 0,
        applicationId: 2,
        serviceName: 'Backup',
        timeInitiate: 1708583755,
        timeImplement: 1708583769,
        timeOngoing: 1708583897,
        timeDone: 1708583911,
        timeUpdated: 1708583911,
        status: 'completed',
        demo: true
    }
];

export const servicePendingDemoData = [
    {
        invoiceId: 250,
        invoiceItemId: 25,
        user: {
            id: 49,
            firstName: 'Mir',
            lastName: 'Sayem',
            fullName: 'Mir Sayem',
            organization: 'Pridesys IT',
            primaryEmail: 'pridesys0080@gmail.com',
            primaryPhone: '0155000080',
            demo: true
        },
        productType: 'service',
        serviceName: 'Installation',
        packageName: 'Installation',
        subscriptionId: 0,
        applicationId: 1,
        timeUpdated: 1708592924,
        status: 'pending',
        demo: true
    },
    {
        invoiceId: 253,
        invoiceItemId: 38,
        user: {
            id: 5,
            firstName: 'Noman',
            lastName: 'Gazi',
            fullName: 'Noman Gazi',
            organization: 'Noman Co..',
            primaryEmail: 'contact@noman.me',
            primaryPhone: '01777777777',
            demo: true
        },
        productType: 'service',
        serviceName: 'Migration',
        packageName: 'Migration',
        subscriptionId: 0,
        applicationId: 5,
        timeUpdated: 1708688903,
        status: 'pending',
        demo: true
    },
    {
        invoiceId: 253,
        invoiceItemId: 36,
        user: {
            id: 5,
            firstName: 'Noman',
            lastName: 'Gazi',
            fullName: 'Noman Gazi',
            organization: 'Noman Co..',
            primaryEmail: 'contact@noman.me',
            primaryPhone: '01777777777',
            demo: true
        },
        productType: 'service',
        serviceName: 'Support Service',
        packageName: 'Support Service',
        subscriptionId: 0,
        applicationId: 6,
        timeUpdated: 1708688903,
        status: 'pending',
        demo: true
    }
];

export default null;
